import { render, staticRenderFns } from "./TCLAPriorityQueue.vue?vue&type=template&id=9ef87b8e&scoped=true"
import script from "./TCLAPriorityQueue.vue?vue&type=script&lang=js"
export * from "./TCLAPriorityQueue.vue?vue&type=script&lang=js"
import style0 from "./TCLAPriorityQueue.vue?vue&type=style&index=0&id=9ef87b8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ef87b8e",
  null
  
)

export default component.exports